<template>
  <v-menu v-model="dropdownIsOpen" location="bottom center" transition="slide-y-transition" offset="4">
    <template #activator="{ props }">
      <v-btn variant="text" rounded class="tour-help" style="height: 40px" v-bind="props">
        <v-icon>far fa-question-circle</v-icon>
        <span class="ml-2">{{ $t('NAV.HELP') }}</span>
        <v-tooltip :disabled="dropdownIsOpen" location="bottom" activator="parent">{{ $t('NAV.HELP_TOOLTIP') }}</v-tooltip>
      </v-btn>

      <!--  MODALS -->
      <help-tips v-if="helpTipsIsOpened" @close="closeModals"></help-tips>
      <help-videos v-if="helpVideosIsOpened" @close="closeModals"></help-videos>
    </template>
    <v-list density="compact">
      <v-list-item target="_blank" rel="noopener" href="https://bubbleplan.net/assets/files/Bubble Plan - Guide rapide d'utilisation.pdf">
        <div class="d-flex align-center"><v-icon start size="x-small">far fa-file-download</v-icon>{{ $t('HELP.USER_GUIDE') }}</div>
      </v-list-item>
      <v-list-item @click="openVideoTutos()">
        <div class="d-flex align-center"><v-icon start size="x-small">far fa-play-circle</v-icon>{{ $t('HELP.VIDEO_TUTOS') }}<span class="label-new ml-1">NEW</span></div>
      </v-list-item>
      <v-list-item @click="openTips()">
        <div class="d-flex align-center"><v-icon start size="x-small">far fa-thumbs-up</v-icon>{{ $t('HELP.TIPS') }}<span class="label-new ml-1">NEW</span></div>
      </v-list-item>
      <v-list-item href="https://bubbleplan.net/questions-reponses-logiciel-gestion-projet" target="_blank" rel="noopener">
        <div class="d-flex align-center"><v-icon start size="x-small">far fa-external-link</v-icon>{{ $t('HELP.FAQ') }}</div>
      </v-list-item>
      <v-list-item href="https://bubbleplan.net/blog" target="_blank" rel="noopener">
        <div class="d-flex align-center"><v-icon start size="x-small">far fa-external-link</v-icon>{{ $t('HELP.BLOG') }}</div>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-if="config == 'planning'" @click="playTour(1)">{{ $t('HELP.REPLAY_TUTORIAL') }}</v-list-item>
      <v-list-item v-if="config == 'planning'" @click="playTour(2)">{{ $t('HELP.ADVANCED_TUTORIAL') }}</v-list-item>
      <v-divider v-if="config == 'planning'"></v-divider>
      <v-list-item @click="openNewVersionMsgBox">{{ $t('HELP.NEW_FEATURES') }}</v-list-item>
      <v-divider></v-divider>
      <v-list-item href="mailto:contact@bubbleplan.net" target="_blank" rel="noopener">
        <div>
          <div>{{ $t('HELP.CONTACT_US') }}</div>
          <v-list-item-subtitle>contact@bubbleplan.net</v-list-item-subtitle>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>

  <!-- MODALS -->
  <new-versions-modal></new-versions-modal>
</template>

<script>
  import useUiNavigationStore from '@/stores/ui/navigation';
  import useUiModalsStore from '@/stores/ui/modals';
  import HelpTips from '@/components/Help/HelpTips.vue';
  import HelpVideos from '@/components/Help/HelpVideos.vue';
  import NewVersionsModal from '@/components/Help/NewVersionsModal.vue';

  export default {
    components: {
      HelpTips,
      HelpVideos,
      NewVersionsModal,
    },
    props: {
      config: { type: String, default: '' }, // planning, projects, manage
    },
    data() {
      return {
        dropdownIsOpen: null,
        uiNavigationStore: useUiNavigationStore(),
        uiModalsStore: useUiModalsStore(),
      };
    },
    computed: {
      helpTipsIsOpened() {
        return this.uiNavigationStore.openedModal == 'help-tips';
      },
      helpVideosIsOpened() {
        return this.uiNavigationStore.openedModal == 'help-videos';
      },
    },
    methods: {
      openTips() {
        this.uiNavigationStore.setOpenedModal('help-tips');
      },
      openVideoTutos() {
        this.uiNavigationStore.setOpenedModal('help-videos');
      },
      closeModals() {
        this.uiNavigationStore.setOpenedModal(null);
      },
      async playTour(level) {
        await this.$router.replace({ query: { tour: level || 1 } });
        this.$router.go();
      },
      openNewVersionMsgBox() {
        this.uiModalsStore.setDisplayNewVersionsWindow(true);
      },
    },
  };
</script>
